import {
    ATTENDANCE_LIST_FETCHING,
    ATTENDANCE_LIST_FAILED,
    ATTENDANCE_LIST_SUCCESS
} from "../actions/types";

const initialState = {
    result: null,
    isFetching:false,
    isError: false
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case ATTENDANCE_LIST_FETCHING:
            return { ...state, result: null, isFetching: true, isError: false };
        case ATTENDANCE_LIST_FAILED:
            return { ...state, result: null, isFetching: false, isError: true };
        case ATTENDANCE_LIST_SUCCESS:
            return { ...state, result: payload, isFetching: false, isError: false };
        default:
            return state;
    }
};